import { lazy } from 'react'

const SettingPass = lazy(() => import('../../views/settingPass/SettingPass'))

const Product = lazy(() => import('../../views/settings/product/Product'))
const Tank = lazy(() => import('../../views/settings/tank/Tank'))
const Meter = lazy(() => import('../../views/settings/meter/Meter'))
const Nozzel = lazy(() => import('../../views/settings/nozzel/Nozzel'))
const Oil = lazy(() => import('../../views/settings/oil/Oil'))
const Ledger = lazy(() => import('../../views/settings/ledger/Ledger'))
const Petrocard = lazy(() => import('../../views/settings/petroCard/PetrolCard'))
const Swipe = lazy(() => import('../../views/settings/swipe/Swipe'))
const OpeningCash = lazy(() => import('../../views/settings/openingCash/OpeningCash'))
const Vehicle = lazy(() => import('../../views/settings/vehicle/vehicle'))
const Shift = lazy(() => import('../../views/settings/shift/Shift'))
const ShiftList = lazy(() => import('../../views/settings/shift/ShiftList'))
const DSMPassword = lazy(() => import('../../views/settings/dsmPassword/DsmPassword'))
const AssignDSMNozzle = lazy(() => import('../../views/settings/assignDsmNozzle/AssignDsmNozzle'))

//reports
const OverAllPurchaseReport = lazy(() => import('../../views/report/purchase/OverAllPurchaseReport'))
const ProductwisePurchaseReport = lazy(() => import('../../views/report/purchase/ProductwisePurchaseReport'))
const OilPurchaseReport = lazy(() => import('../../views/report/purchase/OilPurchaseReport'))
const OilPurchaseReportTwo = lazy(() => import('../../views/report/purchase/OilPurchaseReport-2'))
const LfrReport = lazy(() => import('../../views/report/purchase/LfrPurchaseReport'))
const MonthlyPurchseFuel = lazy(() => import('../../views/report/purchase/MonthlyPurchaseFuelReport'))

//Account
const Voucher = lazy(() => import('../../views/account/voucher'))
const Ledgers = lazy(() => import('../../views/account/ledger'))
const SaleReport = lazy(() => import('../../views/report/sale/SaleReport'))
const TankWiseSaleReport = lazy(() => import('../../views/report/sale/TankWiseSaleReport'))
const ProductWiseSaleReport = lazy(() => import('../../views/report/sale/ProductWiseSaleReport'))
const NozzelWiseSaleReport = lazy(() => import('../../views/report/sale/NozzelWiseSaleReport'))
const OilSaleReport = lazy(() => import('../../views/report/sale/OilSaleReport'))
const SaleOpenClose = lazy(() => import('../../views/report/sale/SaleOpenClose'))
const ProductWiseDetaile = lazy(() => import('../../views/report/sale/ProductWiseDetaile'))
const NozzelWiseDetail = lazy(() => import('../../views/report/sale/NozzelWiseDetail'))
const TankwiseDetaile = lazy(() => import('../../views/report/sale/TankwiseDetaile'))

const StockReport = lazy(() => import('../../views/report/stock/StockReport'))
const VariationReport  = lazy(() => import('../../views/report/stock/VariationReport'))
const OilStockReport  = lazy(() => import('../../views/report/stock/OilStockReport'))

const CreditLedger  = lazy(() => import('../../views/report/creditClient/CreditLedgerReport'))
const CreditLedgerMorshsir  = lazy(() => import('../../views/report/creditClient/LeadgerReportMoreshSir'))
const BillGenration  = lazy(() => import('../../views/report/creditClient/BillGenration'))
const DaywiseBilling  = lazy(() => import('../../views/report/creditClient/DaywiseBillingReport'))
const CreditRecipt  = lazy(() => import('../../views/report/creditClient/CreditReciptReport'))
const BillwiseReport  = lazy(() => import('../../views/report/creditClient/BillwiseReport'))
const OutstandingReport  = lazy(() => import('../../views/report/creditClient/OutstandingReport'))
const ProductwiseCreditReport  = lazy(() => import('../../views/report/creditClient/ProductCreditSaleReport'))

const OverallStaffReport  = lazy(() => import('../../views/report/staff/OverallStaffReport'))
const StaffwiseSaleReport  = lazy(() => import('../../views/report/staff/StaffwiseSaleReport'))
const PaymentReport  = lazy(() => import('../../views/report/staff/PaymentReport'))
const MeterwiseSaleReport  = lazy(() => import('../../views/report/staff/MeterwiseSaleReport'))
const MeterReportDatewise  = lazy(() => import('../../views/report/staff/MeterReportDatewise'))

//Other
const ChequeReport  = lazy(() => import('../../views/report/other/ChequeReport'))
const ExpenseReport  = lazy(() => import('../../views/report/other/ExpenseReport'))
const CardReport  = lazy(() => import('../../views/report/other/CardReport'))
const LedgerOutstandingReport = lazy(() => import('../../views/report/other/LedgerOutstandingReport')) 
const RateReport  = lazy(() => import('../../views/report/other/RateReport'))
const ProductDensity  = lazy(() => import('../../views/report/other/ProductDensityReport'))

const PaymentReportHand  = lazy(() => import('../../views/report/handLooans/PaymentReport'))
const RecieptReport  = lazy(() => import('../../views/report/handLooans/RecieptReport'))
const PaymentRecieptReport  = lazy(() => import('../../views/report/handLooans/PaymentRecieptReport'))
const OutstandingHandlooans  = lazy(() => import('../../views/report/handLooans/OutstandingReport'))

//Daily Log
const DayStart  = lazy(() => import('../../views/dailyLog/DayStart'))
const DayStartMobile  = lazy(() => import('../../views/dailyLog/daystartMobile'))
const ProductDensityDaily  = lazy(() => import('../../views/dailyLog/ProductDensity'))
const ProductDensityMobile  = lazy(() => import('../../views/dailyLog/productDensityMobileView'))
const OilPurchaseFuel  = lazy(() => import('../../views/dailyLog/PurchaseFuel'))
const PurchaseFuelMobile  = lazy(() => import('../../views/dailyLog/PurchaseFuelMobile'))
const PurchaseOil  = lazy(() => import('../../views/dailyLog/PurchaseOil'))
const PurchaseOilMobile  = lazy(() => import('../../views/dailyLog/PurchaseOilMobileView'))
const NozzelGrid  = lazy(() => import('../../views/dailyLog/nozzelGrid/NozzelGrid'))
const NozzelGridMobile  = lazy(() => import('../../views/dailyLog/nozzelGrid-mobile/NozzelGrid'))
const Variation  = lazy(() => import('../../views/dailyLog/VariationDaily'))
const OilSale  = lazy(() => import('../../views/dailyLog/oilSale/oilSale'))
const OilSaleM  = lazy(() => import('../../views/dailyLog/oilSale-mobile/oilSale'))
const PetroCard  = lazy(() => import('../../views/dailyLog/PetroCard'))
const SwipeCard  = lazy(() => import('../../views/dailyLog/SwipeCard'))
const Banking  = lazy(() => import('../../views/dailyLog/banking/Banking'))
const CreditClient  = lazy(() => import('../../views/dailyLog/CreditClient'))
const Receipt  = lazy(() => import('../../views/dailyLog/Receipt'))
const HandLoans  = lazy(() => import('../../views/dailyLog/HandLoans'))
const Advances  = lazy(() => import('../../views/dailyLog/Advances'))
const Expenses  = lazy(() => import('../../views/dailyLog/Expenses'))
const StaffSale  = lazy(() => import('../../views/dailyLog/StaffSale'))
const StaffSallary  = lazy(() => import('../../views/dailyLog/StaffSallary'))
const DayProfit  = lazy(() => import('../../views/dailyLog/DayProfit'))
const StockBook  = lazy(() => import('../../views/dailyLog/StockBook'))
const DayBook  = lazy(() => import('../../views/dailyLog/DayBook'))
const DaySheetPdf  = lazy(() => import('../../views/dailyLog/DaySheetPdf'))
const DaySummary  = lazy(() => import('../../views/dailyLog/DaySummary'))
const Payment  = lazy(() => import('../../views/dailyLog/Payment'))
const DayStartNext  = lazy(() => import('../../views/dailyLog/DayStartNext'))
const DsmApproval = lazy(() => import('../../views/dailyLog/dsmApproval/DsmApproval'))

//billing
const Billing  = lazy(() => import('../../views/billing/Billing'))

//Display
const BalanceSheet  = lazy(() => import('../../views/display/BalanceSheet'))
const ProfitAndLossSheet  = lazy(() => import('../../views/display/ProfitAndLossSheet'))
const OilGstReport  = lazy(() => import('../../views/display/OilGstReport'))

//Stamping
const Stamping  = lazy(() => import('../../views/stamping/Stamping'))

//Profit
const ProfitPerLiterReport  = lazy(() => import('../../views/report/profit/ProfitPerLiterReport'))
const PurchasewiseProfitReport  = lazy(() => import('../../views/report/profit/PurchasewiseProfitReport'))
const RateDiffStockProfitReport  = lazy(() => import('../../views/report/profit/RateDiffStockProfitReport'))


const SessionChecker  = lazy(() => import('../../views/SessionChecker'))

//mobile Side
const DailyLog  = lazy(() => import('../../views/dashboard/ecommerce/MobileView/Dailylog'))
const PurchaseM  = lazy(() => import('../../views/dashboard/ecommerce/MobileView/Purchase'))
const SaleM  = lazy(() => import('../../views/dashboard/ecommerce/MobileView/Sale'))
const CardM  = lazy(() => import('../../views/dashboard/ecommerce/MobileView/Card'))

const PumpMangerRoutes = [

  //Mobile Side
  {
    path: '/dashboard/dailyLog',
    element: <DailyLog />
  },
  {
    path: '/dashboard/purchase',
    element: <PurchaseM />
  },
  {
    path: '/dashboard/sale',
    element: <SaleM />
  },
  {
    path: '/dashboard/card',
    element: <CardM />
  },

  {
    path: '/sessionChecker',
    element: <SessionChecker />
  },

  {
    path: '/settingPass',
    element: <SettingPass />
  },
  {
    path: '/settings/product',
    element: <Product />
  },
  {
    path: '/settings/tank',
    element: <Tank />
  },
  {
    path: '/settings/meter',
    element: <Meter />
  },
  {
    path: '/settings/nozzel',
    element: <Nozzel />
  },
  {
    path: '/settings/oil',
    element: <Oil />
  },
  {
    path: '/settings/ledger',
    element: <Ledger />
  },
 
  {
    path: '/settings/petrocard',
    element: <Petrocard />
  },
  {
    path: '/settings/swipe',
    element: <Swipe />
  },
  {
    path: '/settings/openingCash',
    element: <OpeningCash />
  },
  {
    path: '/settings/vehicle',
    element: <Vehicle />
  },
  {
    path: '/settings/shift',
    element: <Shift />
  },
  {
    path: '/settings/ShiftList',
    element: <ShiftList />
  },
  {
    path: '/settings/dsmPassword',
    element: <DSMPassword />
  },
  {
    path: '/settings/assignDSMNozzle',
    element: <AssignDSMNozzle />
  },  

  //Reports
  //purchase
  {
    path: '/reports/purchase/overAll-report',
    element: <OverAllPurchaseReport />
  },
  {
    path: '/reports/purchase/productwise-report',
    element: <ProductwisePurchaseReport />
  },
  {
    path: '/reports/purchase/oil-report',
    element: <OilPurchaseReport />
  },
  {
    path: '/reports/purchase/oil-report-2',
    element: <OilPurchaseReportTwo />
  },
  {
    path: '/reports/purchase/lfr-report',
    element: <LfrReport />
  },
  {
    path: '/reports/purchase/monthlyPurchseFuel',
    element: <MonthlyPurchseFuel />
  },
  //sale
  {
    path:  '/reports/sale/sale-report',
    element: <SaleReport />
  },
  {
    path:  '/reports/sale/tankWise-report',
    element: <TankWiseSaleReport />
  },
  {
    path:  '/reports/sale/productWise-report',
    element: <ProductWiseSaleReport />
  },
  {
    path:  '/reports/sale/nozzelWise-report',
    element: <NozzelWiseSaleReport />
  },

  {
    path:  '/reports/sale/saleOpenClose',
    element: <SaleOpenClose />
  },
  {
    path: '/reports/sale/oil-report',
    element: <OilSaleReport />
  },
  {
    path:  '/reports/sale/productWise-details-report',
    element: <ProductWiseDetaile />
  },
  {
    path:   '/reports/sale/tankWise-details-report',
    element: <TankwiseDetaile />
  },
  {
    path:   '/reports/sale/nozzelWise-details-report',
    element: <NozzelWiseDetail />
  },
  //purchase
  {
    path:   '/reports/purchase/stock-report',
    element: <StockReport />
  },
  {
    path:   '/reports/purchase/variation-report',
    element: <VariationReport />
  },
  {
    path:   '/reports/purchase/oilStock-report',
    element: <OilStockReport />
  },
//creditClients
  {
    path:   "/reports/creditClients/creditLedgerReportTesting",
    element: <CreditLedgerMorshsir />
  },
  {
    path:   "/reports/creditClients/creditLedgerReport",
    element: <CreditLedger />
  },
  {
    path:   "/reports/creditClients/billGeneration",
    element: <BillGenration />
  },
  {
    path:   "/reports/creditClients/daywiseBillingReport",
    element: <DaywiseBilling />
  },
  {
    path:  "/reports/creditClients/creditRecieptReport",
    element: <CreditRecipt />
  },  {
    path:    "/reports/creditClients/billwiseReport",
    element: <BillwiseReport />
  },
  {
    path:   "/reports/creditClients/outstandingReport",
    element: <OutstandingReport />
  },
  {
    path:   "/reports/creditClients/productCreditSaleReport",
    element: <ProductwiseCreditReport />
  },
  //staff
  {
    path:   "/reports/staff/overallStaffReport",
    element: <OverallStaffReport />
  },
  {
    path:   "/reports/staff/staffwiseSaleReport",
    element: <StaffwiseSaleReport />
  },
  {
    path:   "/reports/staff/paymentReport",
    element: <PaymentReport />
  },
  {
    path:   "/reports/staff/meterwiseSaleReport",
    element: <MeterwiseSaleReport />
  },
  {
    path:   "/reports/staff/meterReportDatewise",
    element: <MeterReportDatewise />
  },

  //Profit
  {
    path:   "/reports/profit/purchasewiseProfitReport",
    element: <PurchasewiseProfitReport/>
  },
  {
    path:   "/reports/profit/profitPerLiterReport",
    element: <ProfitPerLiterReport />
  },
  {
    path:   "/reports/profit/rateDiffStockProfitReport",
    element: <RateDiffStockProfitReport />
  },
  //Other
  {
    path:  "/reports/other/chequeReport",
    element: <ChequeReport />
  },
  {
    path:  "/reports/other/expenseReport",
    element: <ExpenseReport />
  },
  {
    path:  "/reports/other/cardReport",
    element: <CardReport />
  },
  {
    path:  "/reports/other/rateReport",
    element: <RateReport />
  },  
  {
    path:   "/reports/other/productDensityReport",
    element: <ProductDensity />
  },
  {
    path:  "/reports/other/ledgerOutstandingReport",
    element: <LedgerOutstandingReport />
  },
  //handlooans
  {
    path:  "/reports/handLoans/paymentReport",
    element: <PaymentReportHand />
  },
  {
    path:  "/reports/handLoans/recieptReport",
    element: <RecieptReport />
  },
  {
    path: "/reports/handLoans/paymentRecieptReport",
    element: <PaymentRecieptReport />
  },
  {
    path: "/reports/handloan/outstandingReport",
    element: <OutstandingHandlooans />
  },

   //Daily Log
   {
    path:  '/dailyLog/dayStart',
    element: <DayStart />
  },
  {
    path:  '/dailyLog/dayStartM',
    element: <DayStartMobile />
  },
  {
    path:   '/dailyLog/productDensity',
    element: <ProductDensityDaily />
  },
  {
    path:   '/dailyLog/productDensityM',
    element: <ProductDensityMobile />
  },
  {
    path: '/dailyLog/purchaseFuel',
    element: <OilPurchaseFuel />
  },
  {
    path: '/dailyLog/purchaseFuelMob',
    element: <PurchaseFuelMobile />
  },
  {
    path:  '/dailyLog/purchaseOil',
    element: <PurchaseOil />
  },
  {
    path:  '/dailyLog/purchaseOilM',
    element: <PurchaseOilMobile />
  },
  {
    path: '/dailyLog/dsmApproval',
    element: <DsmApproval />
  },
  {
    path:  '/dailyLog/nozzelGrid',
    element: <NozzelGrid />
  },
  {
    path:  '/dailyLog/nozzelGridMob',
    element: <NozzelGridMobile />
  },
  {
    path:   '/dailyLog/variation',
    element: <Variation />
  },
  {
    path: '/dailyLog/oilSale',
    element: <OilSale />
  },
  {
    path: '/dailyLog/oilSaleM',
    element: <OilSaleM />
  },
  {
    path:  '/dailyLog/petroCard',
    element: <PetroCard />
  },
  {
    path:  '/dailyLog/swipeCard',
    element: <SwipeCard />
  },
  {
    path:    '/dailyLog/banking',
    element: <Banking />
  },
  {
    path: '/dailyLog/creditClient',
    element: <CreditClient />
  },
  {
    path:  '/dailyLog/receipt',
    element: <Receipt />
  },
  {
    path:  '/dailyLog/handLoans',
    element: <HandLoans />
  },
  {
    path:  '/dailyLog/advances',
    element: <Advances />
  },
  {
    path: '/dailyLog/payment',
    element: <Payment />
  },
  {
    path:  '/dailyLog/expenses',
    element: <Expenses />
  },

  {
    path:  '/dailyLog/staffSale',
    element: <StaffSale />
  },
  {
    path:     '/report/staff/staffSallary',
    element: <StaffSallary />
  },
  {
    path: '/dailyLog/dayProfit',
    element: <DayProfit />
  },
  {
    path:  '/dailyLog/stockBook',
    element: <StockBook />
  },
  {
    path:   '/dailyLog/dayBook',
    element: <DayBook />
  },
  {
    path:   '/dailyLog/daySheetPdf',
    element: <DaySheetPdf />
  },
  {
    path:  '/dailyLog/daySummary',
    element: <DaySummary />
  },
  {
    path:  '/dailyLog/day-start-next',
    element: <DayStartNext />
  },
  //billing
  {
    path:  '/billing',
    element: <Billing />
  },
  //account
  {
    path: '/account/ledger',
    element: <Ledgers />
  },
  {
    path: '/account/voucher',
    element: <Voucher />
  },

  //Display
  {
    path: '/display/balanceSheet',
    element: <BalanceSheet />
  },
  {
    path: '/display/profitAndLossSheet',
    element: <ProfitAndLossSheet />
  },
  {
    path: '/display/oilGstReport',
    element: <OilGstReport />
  },

  //Stamping
  {
    path: '/stamping',
    element: <Stamping />
  }
]

export default PumpMangerRoutes
